import type { PillarsContent } from "../types";

export const pillars: PillarsContent = {
  title: "The platform Danish research <br>already runs on.",
  pillars: [
    {
      metric: "25k",
      label: "Researchers and students",
      statement:
        "One national platform, one login, all eight Danish universities. Europe's most-used national research cloud by user count.",
      link: "See how it works",
    },
    {
      metric: "0",
      label: "Tokens leaving Denmark",
      statement:
        "Every request is processed on Danish soil, under Danish law. Your data stays in Denmark and is never used for model training.",
      link: "Read the data policy",
    },
    {
      metric: "100%",
      label: "Open, inspectable code",
      statement:
        "Open source under the EUPL licence and ISO/IEC 27001:2022 certified, nine years of public development. Sovereignty is built on trust, and trust demands transparency.",
      link: "Read the source",
    },
  ],
};
